export default __webpack_public_path__ + "static/media/snow.aa47db35.png";